"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSegmentationParameters = void 0;
var _react = require("react");
var _useGetAtpClusterId = require("./useGetAtpClusterId");
var _useGetCustomerInfo = require("./useGetCustomerInfo");
/* istanbul ignore file */

/**
 * Wrapper hook for `useGetAtpClusterId` and `useCustomerInfo` to handle error and loading states for both separate hooks consistently.
 *
 * @deprecated This hook is deprecated and will be removed in the future. Use HeadersProvider and UserSegmentationDataProvider instead.
 */
const useGetSegmentationParameters = ({
  customerId,
  tenant
}) => {
  const {
    atpClusterId,
    error: atpClusterIdError,
    loading: atpClusterIdLoading
  } = (0, _useGetAtpClusterId.useGetAtpClusterId)({
    customerId,
    tenant
  });
  const {
    customerTypeId,
    error: customerInfoError,
    loading: customerInfoLoading,
    visitorSegment
  } = (0, _useGetCustomerInfo.useGetCustomerInfo)({
    customerId
  });
  return (0, _react.useMemo)(() => ({
    atpClusterId,
    customerTypeId,
    visitorSegment,
    loading: atpClusterIdLoading || customerInfoLoading,
    error: atpClusterIdError ?? customerInfoError
  }), [atpClusterId, atpClusterIdError, atpClusterIdLoading, customerInfoError, customerInfoLoading, customerTypeId, visitorSegment]);
};
exports.useGetSegmentationParameters = useGetSegmentationParameters;
